import { gql } from '@apollo/client';

const Fragments = {
  report: gql`
    fragment report on Report {
      reportId
      reportName
      reportFriendlyName
      orderNumber
    }
  `
};

export default Fragments;
